<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <core-table
          :title="config.title"
          :config="config">

          <template v-slot:upsertActions="{item}">
            <v-btn v-if="item._exists && isAdmin" class="mx-1 font-weight-light" :loading="loadingTestEmail" color="success" @click="testSmtp(item)" :id="`button_test_smtp`">TEST</v-btn>
          </template>

        </core-table>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import {getList, post} from '@/api/base_entity.js'

export default {
  data () {
    return {
      config,
      loadingTestEmail: false
    }
  },
  async mounted() {
    for (let i = 0; i < this.config.fields.length; i++) {
      if(this.config.fields[i].value=='sponsor_id') {
        const ret = await getList('sponsor')
        this.config.fields[i].list = ret.data
      }
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters.user.role == 'Administrator'
    },
  },
  methods: {
    async testSmtp(item) {
     
      const ret = await this.$root.$confirm.open('Confirm SMTP test', 'Are you sure you want to send a Test EMAIL using this SMTP?', { color: 'red' })
      if (ret) {
        this.loadingTestEmail = true
        post(`/smtp/${item._entity_id}/test`).then( ret => {
          this.$root.$emit('openSnackbar', {
            message: ret.message,
            color: 'success'
          })
        }).catch(e => {
          this.$root.$emit('openSnackbar', {
            message: e.message,
            color: 'error'
          })
        }).finally( () => {
          this.loadingTestEmail = false
        })
      }
      
    }
  }
}
</script>
